module.exports = __webpack_public_path__ + "img/logo-for-light-bg.1f8327e3.svg";